import Vue from 'vue'
import api from '@/services/api'

const store = {
	namespaced: true,
	state: {
		content: null,
		search: null,
		loading: false,
		error: null,
		// contenu deja charge, par id de dossier ('' pour la racine). Vide a
		// chaque lancement de l'app : c'est un cache de session, pas de l'offline
		cache: {}
	},
	mutations: {
		setcontent (state, content) {
			state.content = content
			state.search = null
		},
		cachecontent (state, {key, content}) {
			// Vue 2 ne detecte pas l'ajout d'une cle : passer par Vue.set
			Vue.set(state.cache, key, content)
		},
		clearcache (state) {
			state.cache = {}
		},
		setsearch (state, search) {
			state.search = search
		},
		setloading (state, loading) {
			state.loading = loading
		},
		seterror (state, error) {
			state.error = error
		}
	},

	actions: {

		async loadContent ({ commit, state }, idfichierdossier) {
			let key = idfichierdossier || ''

			// deja visite : affichage immediat, pas d'aller-retour reseau
			if (state.cache[key]) {
				commit('seterror', null)
				commit('setcontent', state.cache[key])
				return
			}

			commit('setloading', true)
			commit('seterror', null)
			try {
				let url = 'intervention/bibliotheque/content'
				if (idfichierdossier) {
					url += '?idfichierdossier=' + encodeURIComponent(idfichierdossier)
				}
				let call = await api.get({url: url})
				commit('cachecontent', {key: key, content: call.response})
				commit('setcontent', call.response)
			} catch (err) {
				console.log('bibliotheque loadContent', err);
				commit('seterror', err)
			}
			commit('setloading', false)
		},

		// vide le cache : le prochain affichage d'un dossier le rechargera
		refresh ({ commit }) {
			commit('clearcache')
		},

		async runSearch ({ commit }, q) {
			commit('setloading', true)
			commit('seterror', null)
			try {
				let call = await api.get({url: 'intervention/bibliotheque/search?q=' + encodeURIComponent(q)})
				commit('setsearch', call.response)
			} catch (err) {
				console.log('bibliotheque search', err);
				commit('seterror', err)
			}
			commit('setloading', false)
		},

		clearSearch ({ commit }) {
			commit('setsearch', null)
		}
	},
	getters: {
		getContent: state => state.content,
		getSearch: state => state.search,
		isLoading: state => state.loading,
		getError: state => state.error
	},
	modules: {}
}

export default store
